import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { LogOut, Sparkles, ShieldCheck } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const { user, employee, isSuperAdmin, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const displayName = user?.first_name ? `${user.first_name} ${user.last_name || ''}`.trim() : user?.username;

  return (
    <header className="header-container">
      {/* Brand & Tagline */}
      <div className="header-brand" onClick={() => navigate('/dashboard')}>
        <div className="header-brand-logo">
          <Sparkles size={22} />
        </div>
        <div>
          <span className="header-brand-title">
            Mentor<span className="header-brand-highlight">AI</span>
          </span>
          <span className="header-brand-subtitle">
            Onboarding & AI Mentoring Platform
          </span>
        </div>
      </div>



      {/* User Info & Actions */}
      <div className="header-user-section">
        <div className="header-user-details">
          <div>
            <div className="header-user-name">{displayName}</div>
            <div className="header-user-subtitle">
              {isSuperAdmin ? (
                <span className="badge badge-primary" style={{ padding: '1px 6px', fontSize: '0.65rem' }}>
                  <ShieldCheck size={10} /> Super Admin
                </span>
              ) : (
                <span>{employee?.department_detail?.name || 'Employee'} • {employee?.office_id || 'Joinee'}</span>
              )}
            </div>
          </div>
          <div className={`header-user-avatar ${isSuperAdmin ? 'admin' : 'employee'}`}>
            {user?.username?.substring(0, 2).toUpperCase()}
          </div>
        </div>

        <button
          onClick={handleLogout}
          className="btn btn-secondary btn-sm header-logout-btn"
          title="Sign Out"
        >
          <LogOut size={16} />
          <span>Logout</span>
        </button>
      </div>
    </header>
  );
};

export default Header;
